// import featherlight from 'featherlight';
// const fl = featherlight; // Expliciete alias

import 'enter-view';
import flatpickr from 'flatpickr';
import './libraries/track-focus.min.js';

// import './scripts/noconflict.js';
import { real100vw } from './scripts/real100vw.js';
import { scrollHandler } from './scripts/scroll.js';
import { smoothScrollto } from './scripts/smooth-scrollto.js';
import { video } from './scripts/video.js';
import { cookiebar } from './scripts/cookie.js';
import { photoModal } from './scripts/photomodal.js';
import { clickOutsideMenu } from './scripts/click-outside-menu.js';
import './scripts/wp-functions.js';

import './client-specific.js';


jQuery(document).ready(function($) {
    real100vw.init($);
    cookiebar.init($);
    scrollHandler.init($);
    smoothScrollto.init($);
    video.init($);
    clickOutsideMenu.init($);
    photoModal.init($);
});
